"use strict";

angular.module('app.shared.switchToggle.switchToggleDirective', [])
    .directive('switchToggle', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/shared/switchToggle/switchToggleView.html',
                scope: {
                    model: '=?'
                }
            }
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/switchToggle/switchToggleDirective.js